export default __webpack_public_path__ + "static/media/lovingkindness-long.283e4df4.m4a";